'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _query = require('utilities/query');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IngredientService = function () {
  function IngredientService($http) {
    'ngInject';

    _classCallCheck(this, IngredientService);

    this.$http = $http;
  }

  _createClass(IngredientService, [{
    key: 'getDefaultSystemIngredientQuery',
    value: function getDefaultSystemIngredientQuery() {
      return _extends({}, (0, _query.getQuery)(), {
        take: 200,
        orderBy: 'SystemIngredientName',
        direction: 'asc'
      });
    }
  }, {
    key: 'getDefaultUserIngredientQuery',
    value: function getDefaultUserIngredientQuery() {
      return _extends({}, (0, _query.getQuery)(), {
        take: 200,
        orderBy: 'UserIngredientName',
        direction: 'asc'
      });
    }
  }, {
    key: 'searchSystemIngredients',
    value: function searchSystemIngredients(query) {
      return this.$http.get('/odata/SystemIngredientOData', {
        params: _extends({
          $select: 'SystemIngredientId, SystemIngredientName, IUtoMgConversiontRate'
        }, query.top && { $top: query.take }, query.calculateSkip && { $skip: query.calculateSkip() }, {
          $orderby: query.orderBy + ' ' + query.direction
        }, query.filter && { $filter: query.filter.toString() }, {
          $count: true
        })
      });
    }
  }, {
    key: 'searchUserIngredients',
    value: function searchUserIngredients(query) {
      return this.$http.get('/odata/UserIngredientOData', {
        params: _extends({
          $select: 'UserIngredientId, UserIngredientName, ProductCount',
          $top: query.take,
          $skip: query.calculateSkip(),
          $orderby: query.orderBy + ' ' + query.direction
        }, query.filter && { $filter: query.filter.toString() }, {
          $count: true
        })
      });
    }
  }, {
    key: 'addSystemIngredientMapping',
    value: function addSystemIngredientMapping(systemIngredientId, userIngredientIds) {
      return this.$http.post('/api/system_ingredient/' + systemIngredientId + '/user_ingredients', {
        systemIngredientId: systemIngredientId,
        userIngredientIds: userIngredientIds
      });
    }
  }, {
    key: 'removeSystemIngredientMapping',
    value: function removeSystemIngredientMapping(systemIngredientId, userIngredientIds) {
      return this.$http.delete('/api/system_ingredient/' + systemIngredientId + '/user_ingredients', {
        data: {
          systemIngredientId: systemIngredientId,
          userIngredientIds: userIngredientIds
        }
      });
    }
  }]);

  return IngredientService;
}();

exports.default = IngredientService;


// WEBPACK FOOTER //
// ./services/ingredient.service.js